export const DEFAULT_READ_ONLY_MESSAGE =
    "You can view your information, but changes are paused while we complete maintenance.";
export const DEFAULT_CAPTURE_ONLY_MESSAGE =
    "Meeting uploads and meeting bots will continue to work as expected.";

export const DEFAULT_CAPTURE_ONLY_DURATION_MINUTES = 30;

export type WriteFenceMode = "read-only" | "capture-only";

export interface PublicReadOnlyModeState {
    enabled: boolean;
    mode: WriteFenceMode | null;
    message: string | null;
    estimatedAvailableAt: string | null;
}
